export default __webpack_public_path__ + "static/media/OS_Dashboard.b9c5db6f.svg";